import React from 'react';
import { FaCheckCircle, FaAward, FaUsers, FaGlobeAmericas } from 'react-icons/fa';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-content">
          <div className="about-left">
            <span className="section-badge">About IdeasPoint</span>
            <h2 className="section-title">
              Your Trusted Partner for <span className="gradient-text">Digital Excellence</span>
            </h2>
            <p className="about-text">
              At IdeasPoint, we're more than just a consultancy – we're your strategic partner 
              in digital transformation. With a proven track record of serving 20+ clients across 
              the globe, we bring together expertise in web development, digital marketing, brand 
              creation, business consultation, data analytics, and design.
            </p>
            <p className="about-text">
              Our mission is to transform your business vision into reality through innovative 
              solutions, strategic thinking, and exceptional execution. We believe in building 
              long-term partnerships that drive sustainable growth.
            </p>
            
            <div className="about-features">
              <div className="feature-item">
                <FaCheckCircle />
                <span>Client-Centric Approach</span>
              </div>
              <div className="feature-item">
                <FaCheckCircle />
                <span>Proven Track Record</span>
              </div>
              <div className="feature-item">
                <FaCheckCircle />
                <span>Expert Team</span>
              </div>
              <div className="feature-item">
                <FaCheckCircle />
                <span>Innovation Driven</span>
              </div>
            </div>
          </div>

          <div className="about-right">
            <div className="about-cards">
              <div className="about-card">
                <div className="card-icon">
                  <FaGlobeAmericas />
                </div>
                <h3>Global Reach</h3>
                <p>Serving clients across continents with local expertise and global standards</p>
              </div>
              
              <div className="about-card">
                <div className="card-icon">
                  <FaAward />
                </div>
                <h3>Quality Assured</h3>
                <p>Award-winning solutions that exceed expectations and industry standards</p>
              </div>
              
              <div className="about-card">
                <div className="card-icon">
                  <FaUsers />
                </div>
                <h3>Expert Team</h3>
                <p>Seasoned professionals dedicated to your success and growth</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
